function transidgenerator(){
    var transid = Date.now();
    return transid;
}

export default transidgenerator;